import React from 'react';
import type CreateEditDialogType from '@/constants/ui/CreateEditDialogType';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import { Dialogs, useDialogManager } from '@/modules/Dialogs';

export default function useCreateEditOpportunityDialog(
  isOpen: boolean,
  {
    preSelectedConstituentId,
    onClose,
    type,
  }: {
    preSelectedConstituentId?: string;
    onClose: () => void;
    type: CreateEditDialogType;
  },
) {
  const { openDialog } = useDialogManager();

  React.useEffect(() => {
    if (isOpen) {
      openDialog(Dialogs.CREATE_EDIT_OPPORTUNITY, {
        preSelectedConstituentId,
        onClose,
        open: true,
        type,
      });
    }
  }, [isOpen]);
}
